$(window).on('load', function () {
    $('.showcase-local-video').each(function( ) {
        var source = $(this).data('video');
        var html = '';
        html += '<video loop playsinline muted data-object-fit="contain">';
            html += '<source src="' + source + '" type="video/mp4">';
        html += '</video>';
        $(this).prepend(html);

        $(this).on( "mouseenter", function() {
            var video = $(this).find('video');
            video[0].currentTime = 0;
            video.trigger('play');
            
        });
        $(this).on( "mouseout", function() {
            var video = $(this).find('video');
            video.trigger('pause');
            
        });
    });
});
